import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import moment from "moment";

const adicionarMascara = (item, valor) => {
  switch (item) {
    case 1:
      return cpf(valor);
    case 2:
      return cnpj(valor);
    default:
      return valor;
  }
};
const cnpj = (v) => {
  v = v.replace(/\D/g, "");
  v = v.replace(/^(\d{2})(\d)/, "$1.$2");
  v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
  v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
  v = v.replace(/(\d{4})(\d)/, "$1-$2");
  return v;
};

const cpf = (v) => {
  v = v.replace(/\D/g, "");
  v = v.replace(/(\d{3})(\d)/, "$1.$2");
  v = v.replace(/(\d{3})(\d)/, "$1.$2");
  v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  return v;
};

const formatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, month, year].join("/");
};

export const relatorioEntidades = async (params, tipo) => {
  const { data: result } = await ApiService.get(
    "Entidade",
    "RelatorioEntidades",
    params
  );

  if (!result.success) {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "Não foi possivel fazer download do relátorio",
      showConfirmButton: false,
      timer: 1500,
    });

    return null;
  }

  if (result.data.length === 0) {
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Não existem entidades para esse ${tipo}`,
      showConfirmButton: true,
    });

    return null;
  }

  let dadosRelatorio = result.data;
  let dadosExportar = [];

  dadosRelatorio.forEach((e) => {
    let dado = {};
    dado.Empresa = e.empresa.nome;
    dado.Grupo = e.grupo.nome;
    dado.Departamento = e.departamento
      ? e.departamento.nome
      : e.grupo.departamento.nome;
    dado["Data Vigencia Inicio"] = moment(e.dataVigenciaInicio).format(
      "DD/MM/yyyy"
    );
    dado["Data Vigencia Fim"] = e.dataVigenciaFim
      ? moment(e.dataVigenciaFim).format("DD/MM/yyyy")
      : "";
    e.entidadePropriedadeValores.forEach((epv) => {
      dado[epv.grupoPropriedade.nome] = epv.valor;
    });

    dadosExportar.push(dado);
  });

  return {
    relatorioExportar: JSON.parse(JSON.stringify(dadosExportar)),
    nomeArquivo: `Relatorio-Entidades-${tipo}-${Date.now()}.xls`,
  };
};

export const relatorioMonitorPendencias = (pendencias, documentos, status) => {
  return {
    pendenciasExportar: pendencias.map((x) => {
      let object = {};
      let documentosPendentes = {};

      object[x.entidadeReferencia.key] = x.entidadeReferencia.value;

      documentos.forEach((doc) => {
        documentosPendentes[doc] = status[x.documentos[doc]]
          ? status[x.documentos[doc]]
          : " -  ";
      });

      return {
        Empresa: x.empresa,
        "Inicio de Vigência": x.dataVigenciaInicio,
        ...object,
        Departamento: x.departamento,
        ...documentosPendentes,
        Competencia: x.competencia,
      };
    }),
    nomeArquivo: `Monitor-de-pendencias-${Date.now()}.xls`,
  };
};

export const relatorioMonitorPendenciasPeriodo = (pendencias, documentos) => {
  return {
    pendenciasExportar: pendencias.map((x) => {
      let object = {};
      let documentosPendentes = {};

      object[x.entidadeReferencia.key] = x.entidadeReferencia.value;
      if (x.propriedadeSecundaria) {
        object[x.propriedadeSecundaria.key] = x.propriedadeSecundaria.value;
      }
      if (x.propriedadeTerciaria) {
        object[x.propriedadeTerciaria.key] = x.propriedadeTerciaria.value;
      }

      documentos.forEach((doc) => {
        documentosPendentes[doc] = x.documentos[doc];
      });

      return {
        Empresa: x.empresa,
        "Inicio de Vigência": x.dataVigenciaInicio,
        ...object,
        Departamento: x.departamento,
        ...documentosPendentes,
      };
    }),
    nomeArquivo: `Monitor-de-pendencias-por-periodo-${Date.now()}.xls`,
  };
};

export const relatorioPendencias = async (params) => {
  const { data: result } = await ApiService.get(
    "Registro",
    "ListarPendencias",
    {
      ...params,
      carregarPropriedades: true,
      relatorioPendencias: true,
    }
  );

  if (!result.success) {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "Não foi possivel fazer download do relátorio",
      showConfirmButton: false,
      timer: 1500,
    });

    return null;
  }

  if (result.data.length === 0) {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "Não existem pendencias para esse tipo de relatório",
      showConfirmButton: true,
    });

    return null;
  }
  let pendencias = result.data;

  const pendenciasExportar = pendencias.map((p) => {
    return {
      Entidade: p.propriedadesEntidade
        .map((pe) =>
          pe.propriedadeInteligenteID
            ? `${pe.nome}: ${adicionarMascara(
                pe.propriedadeInteligenteID,
                pe.valor
              )}`
            : `${pe.nome}: ${pe.valor}`
        )
        .join(", "),
      "Documento Pendente": p.documento,
      Período: p.periodo,
      Status: p.statusPendenciaNome,
      Grupo: p.grupo,
      Departamento: p.departamento,
      Empresa: p.empresa,
      Observações: p.observacoes,
    };
  });

  return {
    pendenciasExportar: pendenciasExportar,
    nomeArquivo: `Pendencias-${Date.now()}.xls`,
  };
};

export const Status = {
  Reprovado: 0,
  Aprovado: 1,
  AguardandoArquivos: 2,
  AguardandoValidacao: 3,
};
export const relatorioPendenciasStatus = async (params) => {
  const { data: result } = await ApiService.get(
    "Registro",
    "ListarPendenciasStatus",
    {
      carregarPropriedades: true,
      status: Status.Aprovado,
      ...params,
    }
  );

  if (!result.success) {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "Não foi possivel fazer download do relátorio",
      showConfirmButton: false,
      timer: 1500,
    });

    return null;
  }

  if (result.data.length === 0) {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "Não existem pendencias para esse tipo de relatório",
      showConfirmButton: true,
    });

    return null;
  }
  let pendencias = result.data;

  const pendenciasExportar = pendencias.map((p) => {
    return {
      Entidade: p.propriedadesEntidade
        .map((pe) =>
          pe.propriedadeInteligenteID
            ? `${pe.nome}: ${adicionarMascara(
                pe.propriedadeInteligenteID,
                pe.valor
              )}`
            : `${pe.nome}: ${pe.valor}`
        )
        .join(", "),
      "Documento Pendente": p.documento,
      Período: p.periodo,
      Status: p.statusPendenciaNome,
      Grupo: p.grupo,
      Departamento: p.departamento,
      Empresa: p.empresa,
      Observações: p.observacoes,
    };
  });

  return {
    pendenciasExportar: pendenciasExportar,
    nomeArquivo: `Pendencias-${Date.now()}.xls`,
  };
};

export const relatorioPendenciasValidade = (pendencias, documentos) => {
  return {
    pendenciasExportar: pendencias.map((x) => {
      let object = {};
      let documentosPendentes = {};

      object[x.entidadeReferencia.key] = x.entidadeReferencia.value;

      documentos.forEach((doc) => {
        documentosPendentes[doc] = x.documentos[doc]
          ? formatDate(x.documentos[doc])
          : " - ";
      });

      return {
        Empresa: x.empresa,
        "Inicio de Vigência": x.dataVigenciaInicio,
        ...object,
        Departamento: x.departamento,
        ...documentosPendentes,
      };
    }),
    nomeArquivo: `Pendencias-Validade-${Date.now()}.xls`,
  };
};

export default {
  relatorioEntidades,
  relatorioPendencias,
  relatorioPendenciasStatus,
  Status,
  relatorioMonitorPendencias,
  relatorioMonitorPendenciasPeriodo,
  relatorioPendenciasValidade,
};
